import React from 'react';
import { motion } from 'framer-motion';
import { StarFlourish } from './Decorations';
export function Programme() {
  const acts = [{
    time: '8:00 AM',
    name: 'The Setup',
    title: 'How We Got Here',
    desc: 'A whirlwind opener — three decades of web development compressed into about three minutes. The bottlenecks, the breakthroughs, and why this moment is genuinely different.'
  }, {
    time: '8:03 AM',
    name: 'The Trick',
    title: 'AI in Practice — A Lightning Demo',
    desc: 'A live build: a real interface conjured from a prompt in front of your eyes. What works, what does not, and where human judgement still does the heavy lifting.'
  }, {
    time: '8:07 AM',
    name: 'The Reveal',
    title: 'What This Means for Your Team',
    desc: 'The takeaway in plain English: how roles are shifting, what to invest in now, and the one question every business should be asking on Monday morning.'
  }];
  return <section className="py-24 px-4 relative" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-velvet text-parchment rounded-sm p-8 md:p-16 relative shadow-2xl" data-id="element-110">
          {/* Playbill styling */}
          <div className="absolute inset-2 border-2 border-parchment/10 rounded-sm pointer-events-none" data-id="element-111" />
          <div className="absolute inset-3 border border-parchment/5 rounded-sm pointer-events-none" data-id="element-112" />

          <div className="text-center mb-14" data-id="element-113">
            <h2 className="text-xs md:text-sm uppercase tracking-[0.3em] text-carrot font-bold mb-4" data-id="element-114">
              The Morning's
            </h2>
            <h3 className="text-5xl md:text-6xl font-serif text-parchment" data-id="element-115">
              Programme
            </h3>
            <div className="flex justify-center gap-2 mt-6 text-carrot" data-id="element-116">
              <StarFlourish className="w-4 h-4" data-id="element-117" />
              <StarFlourish className="w-4 h-4" delay={0.5} data-id="element-118" />
              <StarFlourish className="w-4 h-4" delay={1} data-id="element-119" />
            </div>
          </div>

          <div className="space-y-12" data-id="element-120">
            {acts.map((act, index) => <div key={index} className="relative pl-8 md:pl-0 md:flex md:gap-8 items-start group" data-id="element-121">
                <div className="hidden md:block w-32 text-right pt-1" data-id="element-122">
                  <span className="font-serif text-xl text-carrot" data-id="element-123">
                    {act.time}
                  </span>
                </div>

                {/* Mobile time */}
                <div className="md:hidden absolute left-0 top-1 w-2 h-2 rounded-full bg-carrot" data-id="element-124" />
                <div className="md:hidden text-carrot font-serif text-lg mb-1" data-id="element-125">
                  {act.time}
                </div>

                <div className="flex-1 md:border-l-2 border-parchment/15 md:pl-8 pb-8 md:pb-0 border-dashed group-last:border-transparent" data-id="element-126">
                  <h4 className="text-2xl md:text-3xl font-serif mb-2 text-parchment" data-id="element-127">
                    {act.name}
                  </h4>
                  <p className="text-xs md:text-sm uppercase tracking-[0.18em] text-carrot/90 mb-4 font-semibold" data-id="element-128">
                    {act.title}
                  </p>
                  <p className="text-parchment/85 text-base md:text-lg leading-relaxed font-light" data-id="element-129">
                    {act.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}